<template>
    <nav class="app-header">
        <div class="app-header-brand"><img src="../../assets/logo.png" @click="showMenu"></div>

        <div class="app-header-user">
          <div class="app-header-user-name" v-if="currentEmployee !== null && currentEmployee !== undefined" :disabled="syncing">
            <font-awesome-icon :icon="['fas', 'user']" /> {{ currentEmployee.name }}&nbsp;&nbsp;

          </div>
        </div>

        <div class="app-header-nav">
          <h3 v-text="title"></h3>
        </div>

      <div class="app-header-icons">

        <font-awesome-icon v-if="online" :icon="['fas', 'wifi']" />
        <font-awesome-icon v-if="!online" :icon="['fas', 'wifi-slash']" />
        <br/>
        <font-awesome-icon  :icon="['fas', batteryIcon]" /><br/>
        <span>{{ batteryLevel }}%</span>
      </div>
    </nav>
</template>

<script>
export default {
  name: 'navbar',

  data() {
    return {
      showInfo: false,
      syncing: false,
      refreshKey: 0,
    }
  },

  methods: {
    showMenu() {
      if (this.$route.name !== 'menu') {
        return this.$router.push({name: 'menu'});
      }

      this.$router.back();
    },

    translateResource(resource) {
      const lang = document.documentElement.lang;

      if (resource.translations && resource.translations[lang]) return resource.translations[lang];

      return resource.name;
    }
  },

  computed: {
    online() {
      return this.$store.getters.online;
    },

    currentDevice() {
      return this.$store.getters.currentDevice;
    },

    currentLocation() {
      return this.$store.getters.currentLocation;
    },

    currentEmployee() {
      return this.$store.getters.currentEmployee;
    },

    batteryLevel() {
      return this.$store.getters.batteryLevel;
    },

    batteryCharging() {
      return this.$store.getters.batteryCharging;
    },

    batteryIcon() {

      console.log('computed');
      if (this.batteryCharging) {
        return 'battery-bolt';
      }

      let level = this.batteryLevel;
      if (!level) {
        return null;
      }

      if (level > 0.95) {
        return 'battery-full'
      }
      if (level > 0.70) {
        return 'battery-three-quarters';
      }
      if (level > 0.45) {
        return 'battery-half';
      }
      if (level > 0.20) {
        return 'battery-quarter';
      }

      return 'battery-empty';
    },

    currentActivity() {
      return this.$store.getters.currentActivityForEmployee;
    },

    currentRow() {
      return this.currentActivity
          ? this.$store.state.rows.find(row => row.id === this.currentActivity.id)
          : null;
    },

    title() {
      if (!this.currentActivity) return '';

      const activity = this.$store.getters.activityById(this.currentActivity.activity_id);
      let str = '';

      str += this.translateResource(activity);

      if (this.currentActivity.team_name !== null && this.currentActivity.team_name !== undefined && this.currentActivity.team_name !== '') {
        str += ' | ' + this.$t('labels.team') + ' ' + this.currentActivity.team_name;
      }

      if (this.currentActivity.packaging !== null && this.currentActivity.packaging !== undefined) {
        str += ' | ' + this.translateResource(this.$store.getters.packagingById(this.currentActivity.packaging));
      }

      if (this.currentActivity.amount !== null && this.currentActivity.amount !== undefined) {
        str += ' - ' + this.currentActivity.amount + 'x';
      }

      if (this.currentActivity.row_id !== null && this.currentActivity.row_id !== undefined) {
        str += ' | ' + this.$t('labels.row') + ' ' + this.$store.state.rows.find(row => row.id === this.currentActivity.row_id).title;
      }

      if (this.currentActivity.row_status !== null && this.currentActivity.row_status !== undefined) {
        str += ' - ' + this.$t('statuses.row.' + this.currentActivity.row_status);
      }

      if (this.currentActivity.row_percentage !== null && this.currentActivity.row_percentage !== undefined) {
        str += ' - ' + this.currentActivity.row_percentage + '%';
      }

      return str;
    },

    isManager() {
      return this.$store.getters.currentLocation
          ? this.$store.getters.currentLocation.managers.find((manager) => manager.id === this.currentEmployee.id)
          : false;
    }
  },

  mounted() {
    window.events.$on('synced', () => this.syncing = false);
  },

  beforeDestroy() {
    window.events.$off('synced');
  }
}
</script>
